import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, AlertTriangle, CheckCircle2 } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { openWa } from "@/lib/wa";

const S = "https://static.prod-images.emergentagent.com/jobs/fda92389-ba5f-436d-8064-e3275d1507fa/images";

export default function TpmsPage() {
  const { pick } = useLang();
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");

  const send = () => {
    openWa(`السلام عليكم، أرغب في الاستفسار عن برمجة أو استبدال حساسات الكفرات من ميرو.\nنوع السيارة: ${make || "____"}.\nالموديل: ${model || "____"}.\nسنة الصنع: ${year || "____"}.\nالحي: ____.`);
  };

  return (
    <main>
      <SEO title="حساسات الكفرات وبرمجتها TPMS في الرياض | ميرو" description="حساسات الكفرات.. دقة في المراقبة واهتمام بسلامتك. تعرف على وظيفة نظام مراقبة ضغط الإطارات، الفرق بين الحساسات المباشرة وغير المباشرة، ومتى تحتاج إلى برمجة أو استبدال — استفسر عبر واتساب 0507359999" path="/tpms" />
      <section className="relative overflow-hidden pt-32 sm:pt-40">
        <div className="pointer-events-none absolute -top-32 start-1/3 h-[400px] w-[400px] rounded-full bg-gold/10 blur-[140px]" />
        <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 pb-16 lg:grid-cols-[1.2fr_1fr] lg:px-8">
          <div>
            <p className="eyebrow mb-4">TPMS CENTER</p>
            <h1 className="text-3xl font-extrabold leading-[1.4] text-white sm:text-4xl lg:text-5xl" data-testid="tpms-title">حساسات الكفرات.. <span className="gold-text">دقة في المراقبة واهتمام بسلامتك</span></h1>
            <p className="mt-5 max-w-2xl text-base leading-9 text-mist">نظام مراقبة ضغط الإطارات يحرس كفراتك لحظة بلحظة. تعرّف هنا على كيفية عمله ومتى تحتاج الحساسات إلى فحص أو برمجة أو استبدال.</p>
            <button onClick={send} className="btn-gold mt-8" data-testid="tpms-enquiry-cta"><MessageCircle size={18} /> {pick("استفسر عن حساس سيارتك", "Ask about your car's sensor")}</button>
          </div>
          <Reveal>
            <img src={`${S}/e4854a8ddf71e260b0c21f7ca15364aa54c439c664d8c91509b20ce407e64e0c.jpeg`} alt="حساس ضغط الإطارات TPMS داخل العجلة" className="w-full rounded-[2rem] border border-white/10 shadow-2xl shadow-black/50" />
          </Reveal>
        </div>
      </section>

      <section className="border-t border-white/5 bg-coal/40 py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {[
              { ar: "وظيفة نظام TPMS", en: "What TPMS does", txt: "ينبّهك النظام عند انخفاض ضغط أحد الكفرات عن الحد الآمن، قبل أن يتحول النقص إلى بنشر أو تأثير على الثبات ومسافة الكبح." },
              { ar: "الحساسات المباشرة", en: "Direct sensors", txt: "حساس صغير داخل كل عجلة يقيس الضغط الفعلي ويرسل القراءة للشاشة. أدق وأوضح، وهو الأكثر انتشاراً في السيارات الحديثة." },
              { ar: "الحساسات غير المباشرة", en: "Indirect systems", txt: "تعتمد على حساسات السرعة في نظام ABS لاكتشاف اختلاف دوران الكفر. لا تعرض أرقاماً وتحتاج معايرة بعد تغيير الضغط أو تدوير الكفرات." },
              { ar: "متى تحتاج الحساسات فحصاً؟", en: "When to inspect", txt: "عند وميض لمبة TPMS، أو اختفاء قراءة كفر من الشاشة، أو قراءات غير منطقية، أو بعد خدمة كفرات حديثة." },
              { ar: "متى تحتاج برمجة أو إعادة تعريف؟", en: "When programming is needed", txt: "بعد استبدال حساس، أو تركيب عجلات جديدة، أو تبديل مجموعات كفرات، أو تدوير الكفرات في سيارات تربط الحساس بمكانه." },
              { ar: "أسباب ظهور تحذير الضغط", en: "Why the light comes on", txt: "نقص هواء حقيقي، تغيرات حرارة، نقص هواء بطيء لم يُكتشف، أو خلل في حساس أو تواصله. الفحص الفني هو الفاصل بين هذه الحالات." },
            ].map((c, i) => (
              <Reveal key={i} delay={i % 3}>
                <div className="h-full rounded-3xl border border-white/10 bg-ink/70 p-7">
                  <h2 className="text-lg font-bold text-gold">{pick(c.ar, c.en)}</h2>
                  <p className="mt-3 text-sm leading-8 text-zinc-300">{pick(c.txt, c.txt)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-2 lg:px-8">
          <Reveal>
            <div className="rounded-3xl border border-gold/25 bg-coal/60 p-8">
              <h2 className="mb-6 flex items-center gap-2 text-xl font-bold text-white"><MessageCircle size={20} className="text-gold" /> {pick("استفسر عن حساس سيارتك", "Ask about your car's sensor")}</h2>
              <div className="grid gap-4 sm:grid-cols-3">
                <input className="field" placeholder={pick("نوع السيارة", "Car make")} value={make} onChange={(e) => setMake(e.target.value)} data-testid="tpms-make-input" />
                <input className="field" placeholder={pick("الموديل", "Model")} value={model} onChange={(e) => setModel(e.target.value)} data-testid="tpms-model-input" />
                <input className="field" placeholder={pick("سنة الصنع", "Year")} value={year} onChange={(e) => setYear(e.target.value)} data-testid="tpms-year-input" />
              </div>
              <button onClick={send} className="btn-gold mt-5 w-full" data-testid="tpms-send-button">{pick("إرسال الاستفسار عبر واتساب", "Send via WhatsApp")}</button>
              <p className="mt-4 text-[11px] leading-6 text-dim">{pick("ليست كل الحساسات متوافقة مع جميع السيارات — سنؤكد التوافق والخيار المناسب في المحادثة.", "Not every sensor fits every car — compatibility is confirmed in the chat.")}</p>
            </div>
          </Reveal>
          <Reveal delay={1}>
            <div className="space-y-4">
              <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-coal/60 p-6">
                <AlertTriangle size={20} className="mt-0.5 shrink-0 text-gold" />
                <p className="text-sm leading-7 text-zinc-300">{pick("لا تقدم هذه الصفحة تشخيصاً نهائياً لسيارتك اعتماداً على رسالة التحذير وحدها — الفحص الفني بجهاز قراءة الحساسات هو الذي يحدد الحالة بدقة.", "This page gives general guidance, not a final diagnosis — a proper sensor scan determines the actual state.")}</p>
              </div>
              <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-coal/60 p-6">
                <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-gold" />
                <p className="text-sm leading-7 text-zinc-300">{pick("أهمية اختيار الحساس المتوافق: الترددات وبروتوكولات الاتصال تختلف بين المصنّعين والموديلات، وتركيب حساس غير متوافق يعني غياب القراءة كلياً.", "Sensor compatibility matters: frequencies and protocols differ by maker and model; a mismatched sensor simply won't show readings.")}</p>
              </div>
              <Link to="/order" className="btn-ghost w-full" data-testid="tpms-order-link">{pick("أو اطلب الخدمة عبر نموذج الطلب", "Or order via the request form")}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
